// src/components/services/orderServices.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// ✅ Helper per ottenere il token
const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
        console.warn('⚠️ ATTENZIONE: Token non trovato!');
    }
    return {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

export const orderService = {
    
    // ✅ CREA ORDINE - Con token!
    createOrder: async (orderData) => {
        try {
            console.log('📦 Invio ordine a:', `${API_URL}/orders`);
            console.log('🔑 Headers:', getAuthHeaders());
            console.log('📦 Dati:', orderData);
            
            const response = await axios.post(
                `${API_URL}/orders`, 
                orderData, 
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            console.log('✅ Risposta server:', response.data);
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore creazione ordine:', error);
            
            if (error.response?.status === 401) {
                // Token scaduto o non valido
                localStorage.removeItem('access_token');
                return {
                    success: false,
                    message: 'Sessione scaduta. Effettua nuovamente il login.',
                    redirectToLogin: true
                };
            }
            
            const errorMessage = error.response?.data?.message || 
                                error.response?.data?.error || 
                                'Errore durante la creazione dell\'ordine';
            return { 
                success: false, 
                message: errorMessage 
            };
        }
    },
    
    // ✅ RECUPERA DETTAGLI ORDINE
    getOrderDetails: async (orderId) => {
        try {
            console.log('🔍 Recupero ordine:', orderId);
            
            const response = await axios.get(
                `${API_URL}/orders/${orderId}`, 
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore recupero ordine:', error);
            
            if (error.response?.status === 401) {
                return {
                    success: false,
                    message: 'Sessione scaduta',
                    redirectToLogin: true
                };
            }
            
            return { 
                success: false, 
                message: error.response?.data?.message || 'Errore nel recupero dell\'ordine'
            };
        }
    },
    
    // ✅ RECUPERA ORDINI UTENTE
    getUserOrders: async (limit = 10, offset = 0) => {
        try {
            console.log('🔍 Recupero ordini utente');
            
            const response = await axios.get(
                `${API_URL}/orders/user`, 
                {
                    params: { limit, offset },
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore recupero ordini:', error);
            return { 
                success: false, 
                orders: [],
                message: error.response?.data?.message || 'Errore nel recupero degli ordini'
            };
        }
    },
    
    // ✅ AGGIORNA STATO PAGAMENTO
    updatePaymentStatus: async (orderId, paymentData) => {
        try {
            console.log('💰 Aggiornamento pagamento:', { orderId, paymentData });
            
            const response = await axios.put(
                `${API_URL}/orders/${orderId}/payment-status`,
                paymentData,
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore aggiornamento pagamento:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Errore nell\'aggiornamento del pagamento'
            };
        }
    },
    
    // ✅ ANNULLA ORDINE
    cancelOrder: async (orderId) => {
        try {
            console.log('🗑️ Annullamento ordine:', orderId);
            
            const response = await axios.put(
                `${API_URL}/orders/${orderId}/cancel`,
                {},
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore annullamento ordine:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Errore nell\'annullamento dell\'ordine'
            };
        }
    },
    
    // ✅ AGGIORNA INDIRIZZO ORDINE
    updateOrderAddress: async (orderId, addressData) => {
        try {
            console.log('📍 Aggiornamento indirizzo:', { orderId, addressData });
            
            const response = await axios.put(
                `${API_URL}/orders/${orderId}/address`,
                addressData,
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore aggiornamento indirizzo:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Errore nell\'aggiornamento dell\'indirizzo'
            };
        }
    },
    
    // ✅ TRACKING SPEDIZIONE
    trackShipment: async (orderId) => {
        try {
            console.log('📮 Tracking spedizione:', orderId);
            
            const response = await axios.get(
                `/orders/${orderId}/tracking`,
                {
                    headers: getAuthHeaders(),
                    withCredentials: true
                }
            );
            
            return response.data;
            
        } catch (error) {
            console.error('❌ Errore tracking:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Errore nel recupero del tracking'
            };
        }
    }
};

export default orderService;